// removed by extract-text-webpack-plugin
module.exports = {"text800":"qxAmgfkZ_guaiK2odiEvn","text700":"_25gHrY4VB1kAomt5W7xFu0","header":"_1fPOTj0xwvyBMbUWzqI_1a","text600":"aQPiLPu5pjOp11gvgZTKj","text500":"_13izDX39pDuaBzx9rPM6wp","text400":"kq0auqqt8N8fuw48odXsu","text300":"_3PvrvPLkQHf8_ZDwFWWppO","text200":"_3BIRUgt--CrQXRVwkQu9ZF","textParagraph":"_1p_ZwB3TEmSDcG2c1y4bd5","crimp":"_20Mk_onGf4dseI3c39x-P0","trim":"_1Xxwj0PGySIy7KcsVHwtpj"};


//////////////////
// WEBPACK FOOTER
// ./src/imports/styles/extend.card.scss
// module id = 122
// module chunks = 0